<template lang="pug">
.question
  .question__title(@click="toggle")
    h3.question__title-text( :class="{'question__title-text-opened': isExpanded}") {{ title }}
    .question__title-icon
      MinusIcon(v-if="isExpanded")
      PlusIcon(v-else)
  .question__text(v-if="isExpanded") {{ text }}
</template>

<script>
import PlusIcon from '@/components/icons/gift-cards/Plus'
import MinusIcon from '@/components/icons/gift-cards/Minus'

export default {
  components: {
    PlusIcon,
    MinusIcon
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    isExpanded: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle () {
      this.$emit('open', this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.question {
  &__title {
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &-text {
      font-weight: 700;
      font-size: 16px;
      color: #ffffff;

      &-opened {
        color: #a69eff;
      }
    }

    &-icon {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
      margin-left: $gap * 0.5;
      display: flex;
      align-items: center;
      margin-top: $gap * 0.25;
    }
  }

  &__text {
    margin-top: $gap * 0.5;
  }
}
</style>
